import { render, staticRenderFns } from "./Stockouts.vue?vue&type=template&id=520c9b3c&scoped=true"
import script from "./Stockouts.vue?vue&type=script&lang=js"
export * from "./Stockouts.vue?vue&type=script&lang=js"
import style0 from "./Stockouts.vue?vue&type=style&index=0&id=520c9b3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520c9b3c",
  null
  
)

export default component.exports